export default __webpack_public_path__ + "static/media/forestly-expl-nn-base_DE.eb111a1a.png";